import { HORIZONTAL_ASPECTS_STRING } from '@anm/data/aspects';

import { TemplatePage } from './types';

const live_streaming_page: TemplatePage = {
  header: {
    color: '#BFC3FF',
    icon: 'images/video-templates/streaming.jpg',
    title: 'Live Streaming Templates',
    title_meta: '200+ Free Editable Live Streaming Templates',
    description_meta:
      'Create eye-catching intros & outros, informative lower thirds, scroll-stopping thumbnails, and more with ' +
      'our collections of customizable templates for live streaming.',
    description:
      'Take your live videos to the next level with our collections of customizable templates for live streaming. ' +
      'Pick a style of your choice and create eye-catching intros & outros, informative lower thirds, scroll-stopping ' +
      'thumbnails, and many more to make your live streams look more professional and unique.'
  },
  footer: {
    category: 'Live streaming',
    description:
      'With amazing collections of editable live streaming templates, you will be able to freshen up the ' +
      'look and feel of your live videos without the need to hire professional motion designers. All the templates are ' +
      'free and easy to customize to your branding and needs.'
  },
  content: [
    {
      type: 'slider',
      title: 'Christmas Sweater theme',
      name: 'live-streaming-christmas-sweater-theme',
      search: {
        name: 'ChristmasSweaterTheme',
        tags: 'ChristmasSweaterTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Holiday Season Theme',
      name: 'live-streaming-holiday-season-theme',
      search: {
        name: 'HolidaySeasonTheme',
        tags: 'HolidaySeasonTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Old Hollywood Theme',
      name: 'live-streaming-old-hollywood-theme',
      search: {
        name: 'OldHollywoodTheme',
        tags: 'OldHollywoodTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Poinsettia Theme',
      name: 'live-streaming-poinsettia-theme',
      search: {
        name: 'PoinsettiaTheme',
        tags: 'PoinsettiaTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Festive Theme',
      name: 'live-streaming-festive-theme',
      search: {
        name: 'FestiveTheme',
        tags: 'FestiveTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Thanksgiving theme',
      name: 'live-streaming-thanksgiving-theme',
      search: {
        name: 'ThanksgivingTheme',
        tags: 'ThanksgivingTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Halloween theme',
      name: 'live-streaming-halloween-theme',
      search: {
        name: 'HalloweenTheme',
        tags: 'HalloweenTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Interior design theme',
      name: 'live-streaming-interior-design-theme',
      search: {
        name: 'InteriorDesignTheme',
        tags: 'InteriorDesignTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Makeup theme',
      name: 'live-streaming-makeup-theme',
      search: {
        name: 'MakeupTheme',
        tags: 'MakeupTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Medical theme',
      name: 'live-streaming-medical-theme',
      search: {
        name: 'MedicalTheme',
        tags: 'MedicalTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Remote work theme',
      name: 'live-streaming-remote-work-theme',
      search: {
        name: 'RemoteWorkTheme',
        tags: 'RemoteWorkTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Fitness theme',
      name: 'live-streaming-fitness-theme',
      search: {
        name: 'FitnessTheme',
        tags: 'FitnessTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Night city theme',
      name: 'live-streaming-night-city-theme',
      search: {
        name: 'NightCityTheme',
        tags: 'NightCityTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Gradient business theme',
      name: 'live-streaming-gradient-business-theme',
      search: {
        name: 'BusinessGradientTheme',
        tags: 'BusinessGradientTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Cooking show theme',
      name: 'live-streaming-cooking-show-theme',
      search: {
        name: 'CookingShowTheme',
        tags: 'CookingShowTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
  
    {
      type: 'slider',
      title: 'Neon smoke theme',
      name: 'live-streaming-neon-smoke-theme',
      search: {
        name: 'NeonSmokeTheme',
        tags: 'NeonSmokeTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Gradient Theme',
      name: 'live-streaming-gradient-theme',
      search: {
        name: 'GradientTheme',
        tags: 'GradientTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Yogurt theme',
      name: 'live-streaming-yogurt-theme',
      search: {
        name: 'YogurtTheme',
        tags: 'YogurtTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Coffee theme',
      name: 'live-streaming-coffee-theme',
      search: {
        name: 'CoffeeTheme',
        tags: 'CoffeeTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'spiritual theme',
      name: 'live-streaming-spiritual-theme',
      search: {
        name: 'SpiritualTheme',
        tags: 'SpiritualTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Nature theme',
      name: 'live-streaming-nature-theme',
      search: {
        name: 'NatureTheme',
        tags: 'NatureTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'honeycomb theme',
      name: 'live-streaming-honeycomb-theme',
      search: {
        name: 'HoneycombTheme',
        tags: 'HoneycombTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'geometric theme',
      name: 'live-streaming-geometric-theme',
      search: {
        name: 'GeometricTheme',
        tags: 'GeometricTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'dark peach theme',
      name: 'live-streaming-dark-peach-theme',
      search: {
        name: 'DarkPeachTheme',
        tags: 'DarkPeachTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'subtle theme',
      name: 'live-streaming-subtle-bw-theme',
      search: {
        name: 'SubtleBWTheme',
        tags: 'SubtleBWTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'acid pastel theme',
      name: 'live-streaming-acid-pastel-theme',
      search: {
        name: 'AcidPastelTheme',
        tags: 'AcidPastelTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'color bars theme',
      name: 'live-streaming-color-bars-theme',
      search: {
        name: 'ColorBarsTheme',
        tags: 'ColorBarsTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'black star theme',
      name: 'live-streaming-black-star-theme',
      search: {
        name: 'BlackStarTheme',
        tags: 'BlackStarTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Company theme',
      name: 'live-streaming-wave-video-theme',
      search: {
        name: 'WavevideoTheme',
        tags: 'WavevideoTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'US theme',
      name: 'live-streaming-us-theme',
      search: {
        name: 'USTheme',
        tags: 'USTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Emerald theme',
      name: 'live-streaming-emerald-theme',
      search: {
        name: 'EmeraldTheme',
        tags: 'EmeraldTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Linkedin remastered theme',
      name: 'live-streaming-linkedin-remastered-theme',
      search: {
        name: 'LinkedInRemasteredTheme',
        tags: 'LinkedInRemasteredTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    
    {
      type: 'slider',
      title: 'SMD Summit theme',
      name: 'live-streaming-smd-summit-theme',
      search: {
        name: 'SMDSummitTheme',
        tags: 'SMDSummitTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Romantic Valentine’s Day theme',
      name: 'live-streaming-valentine-theme',
      search: {
        name: 'RomanticValentineDayTheme',
        tags: 'RomanticValentineDayTheme',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    }
  ]
};

export default live_streaming_page;
